import React from 'react'
import './styles.scss'

interface Props {
  text: string | JSX.Element
}

export const Answer = ({ text }: Props) => (
  <div className='Answer'>
    <div className='segment'>
      <div className='text'>{text}</div>
      {/* <div className='arrow-down' /> */}
    </div>
    <div className='person'>
      <img src={require('images/siegrist.png')} />
    </div>
  </div>
)
